import { useLocation, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

import CampaignBenefits from '../components/Campaign/CampaignBenefits'
import CampaignTabsAccordion from '../components/Campaign/CampaignTabsAccordion'
import CampaignLinks from '../components/Campaign/CampaignLinks'
import CampaignFaqs from '../components/Campaign/CampaignFaqs'
import Disclaimer from '../components/Disclaimer/Disclaimer'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import CampaignBanner from '../components/Campaign/CampaignBanner'
import CampaignVideoLinks from '../components/Campaign/CampaignVideoLinks'

import useFetch from '../hooks/useFetch'
import useIsMobile from '../hooks/useIsMobile'

const Campaign = () => {
  const { slug } = useParams()
  const isMobile = useIsMobile()
  const transferData = (resp) => resp?.data?.[0]
  const location = useLocation()
  const isCampaignSmsRoute = location.pathname === '/c'

  const avoidRtl = false

  const apiSlug = isCampaignSmsRoute ? 'campaigns' : slug
  const { data, loading, error } = useFetch(apiSlug, transferData)

  if (error?.hasError) {
    return <ErrorComponent errorMessage={error?.errorMessage} />
  }

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  const renderSection = (section) => {
    switch (section.sectiontype) {
      case 'banner': {
        let images = isMobile ? section?.mobile_banner : section?.image
        return (
          <>
            {images && images?.length > 0 && <CampaignBanner images={images} />}
          </>
        )
      }
      case 'benefits': {
        return (
          <>
            {section ? (
              <CampaignBenefits
                title={section?.title}
                description={section?.description}
                cardHeader={section?.sub_title}
                cards={section?.cards}
                avoidRtl={avoidRtl}
              />
            ) : null}
          </>
        )
      }
      case 'tabs': {
        return (
          <CampaignTabsAccordion
            tabs={section?.tabs}
            slug={slug}
            avoidRtl={avoidRtl}
          />
        )
      }
      case 'quick-links': {
        return <CampaignLinks links={section?.links} title={'Quick links'} />
      }
      case 'faqs': {
        return (
          <CampaignFaqs
            title={section?.title}
            questions={section?.questions}
            seeMore={section?.see_more}
            avoidRtl={avoidRtl}
          />
        )
      }
      case 'disclaimer': {
        return (
          <>
            {section ? (
              <div className="page-container my-5">
                <Disclaimer
                  title={section?.disclaimer_title}
                  description={section?.disclaimer_description}
                />
              </div>
            ) : null}
          </>
        )
      }
      case 'video-links': {
        return (
          <>
            {section?.tabs?.length > 0 ? (
              <CampaignVideoLinks
                title={section?.title}
                description={section?.description}
                tabs={section?.tabs}
                avoidRtl={avoidRtl}
              />
            ) : null}
          </>
        )
      }
      default:
        return ''
    }
  }

  return (
    <div
      className="pb-10"
      style={{
        direction: avoidRtl ? 'ltr' : 'inherit',
      }}
    >
      {data && data?.blocks?.length > 0
        ? data?.blocks?.map((eachData, index) => {
            return (
              <div key={`${eachData.sectiontype}-${eachData.id}-${index}`}>
                {renderSection(eachData)}
              </div>
            )
          })
        : null}
    </div>
  )
}

export default Campaign
